import React from 'react';

export interface IconProps {
  size?: number;
  className?: string;
  color?: string;
}

export const IconSun: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="10" cy="10" r="3" stroke={color} strokeWidth="1.5"/>
    <path d="M10 2V3M10 17V18M18 10H17M3 10H2M15.657 4.343L14.95 5.05M5.05 14.95L4.343 15.657M15.657 15.657L14.95 14.95M5.05 5.05L4.343 4.343" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
